import {I18NService} from './utils/i18n.service';
import {GLOBALS} from '../../app-globals';
import {environment} from 'src/environments/environment';

/**
 * Babse component.
 */
export class BaseService {

    i18n: I18NService;

    /*
     * Contructor.
     */
    constructor() {
        this.logd(" service-instance created !");
        this.i18n = GLOBALS.i18n;
    }

    /**
     * Logs.
     */
    logd(aMessage: String) {
        if (!environment.production) {
            console.log("[" + this.constructor.name + "] " + aMessage);
        }
    }

    /**
     * Logs.
     */
    logi(aMessage: String) {
        console.log("[" + this.constructor.name + "] " + aMessage);
    }

    /**
     * Transates
     */
    v(aKey: string): string {
        return this.i18n.v(aKey);
    }

}